import CommonEnvs from './common/env';
import { devUrls } from './constants/dev-constant';

const createApiConfig = (baseUrl: string) => ({
  base_url: baseUrl,
  useCustomHeaders: true,
});

export default {
  ...CommonEnvs,
  API: {
    'auth-api': createApiConfig(devUrls.authServiceUrl),
    'provider-api': createApiConfig(devUrls.providerServiceUrl),
    'macros-api': createApiConfig(devUrls.macrosServiceUrl),
    'appointment-api': createApiConfig(devUrls.appointmentServiceUrl),
    'ehr-api': createApiConfig(devUrls.ehrServiceUrl),
    'transcript-api': createApiConfig(devUrls.transcriptServiceUrl),
    'graphql-api': createApiConfig(devUrls.graphqlApiUrl),
    'gwp-api': createApiConfig(devUrls.gwpServiceUrl),
    'signup-api': { base_url: devUrls.signupServiceUrl },
    'nrt-api': { base_url: devUrls.nrtServerUrl },
    'user-management-api': { base_url: devUrls.userManagementServiceUrl },
    'sso-api': createApiConfig(devUrls.ssoServiceUrl),
    'text-expander-api': createApiConfig(devUrls.textExpanderServiceUrl),
  },
  URL: {
    'signup-url': 'https://g-dev-go.augmedix.com/signup',
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyDFi8Nl_uCCAmH_N6wktLBmiPDMU76-Vio',
    authDomain: 'gcp-dev-env-385616.firebaseapp.com',
    projectId: 'gcp-dev-env-385616',
    storageBucket: 'gcp-dev-env-385616.firebasestorage.app',
    messagingSenderId: '275532120624',
    appId: '1:275532120624:web:ca83debc91f8f6ae2863f5',
    measurementId: 'G-GVC75BQ1BF',
  },
};
